/* Scribble Snacks phone-model picker (Poppy, 29 Sep 2026; Ben: "improve the on-page variant selector design").
   Replaces the wall of model pills with: brand tabs (only when a product spans brands), a trigger showing the chosen
   model, and a panel with search + models grouped by series (newest first, the order of the product's option values).
   It never owns state: every choice checks the theme's native radio (or select) for the "Model" option and fires
   'change', so Dawn's own flow updates price, availability, the add-to-cart variant id and ?variant= in the URL.
   The native Model fieldset is only hidden once this script has run (.ss-pp-on), so the page works without JS.
   Loaded only by templates/product.phone-case.json. Rollback: ops/theme-backups/2026-09-29-phone-picker/. */
(function () {
  'use strict';
  var MIN_VALUES = 7; // fewer than this: the native pills are fine (e.g. AirPods 1 & 2 / 3 / Pro)
  var OPTION_RE = /^(model|phone model|compatible model|device)$/i;
  var uid = 0;

  function brandOf(v) {
    if (/^iphone/i.test(v)) return 'iPhone';
    if (/galaxy|samsung/i.test(v)) return 'Samsung';
    if (/pixel/i.test(v)) return 'Pixel';
    if (/airpods/i.test(v)) return 'AirPods';
    return 'Other';
  }
  function seriesOf(v) {
    var m;
    if ((m = v.match(/^iPhone (\d+)/))) return 'iPhone ' + m[1] + ' series';
    if (/^iPhone Air/.test(v)) return 'iPhone Air';
    if (/^iPhone X/.test(v)) return 'iPhone X, XS & XR';
    if (/^iPhone SE/.test(v)) return 'iPhone SE';
    if ((m = v.match(/^Galaxy (S\d+)/))) return 'Galaxy ' + m[1] + ' series';
    if (/^Galaxy Z Flip/.test(v)) return 'Galaxy Z Flip';
    if (/^Galaxy Z Fold/.test(v)) return 'Galaxy Z Fold';
    if (/^Galaxy A/.test(v)) return 'Galaxy A series';
    if ((m = v.match(/^Pixel (\d+)/))) return 'Pixel ' + m[1] + ' series';
    return brandOf(v);
  }
  function norm(s) { return String(s).toLowerCase().replace(/iphone|galaxy|samsung|google/g, '').replace(/[^a-z0-9]/g, ''); }

  function liveSelects(pi) {
    var all = pi.querySelectorAll('variant-selects');
    for (var i = 0; i < all.length; i++) if (all[i].style.display !== 'none') return all[i];
    return null;
  }
  // Returns {group, kind:'radio'|'select', values:[{value, available, el}], checked}
  function readNative(pi) {
    var vs = liveSelects(pi);
    if (!vs) return null;
    var groups = vs.querySelectorAll('fieldset, .product-form__input--dropdown');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var radios = g.querySelectorAll('input[type="radio"]');
      if (radios.length && OPTION_RE.test((radios[0].dataset.optionName || '').trim())) {
        var vals = [], checked = null;
        radios.forEach(function (r) {
          var unavailable = r.classList.contains('disabled') || r.disabled;
          vals.push({ value: r.value, available: !unavailable, el: r });
          if (r.checked) checked = r.value;
        });
        return { vs: vs, group: g, kind: 'radio', values: vals, checked: checked, position: i };
      }
      var sel = g.querySelector('select');
      if (sel) {
        var lab = g.querySelector('label');
        var name = (sel.name || '').replace(/^options\[|\]$/g, '');
        if (OPTION_RE.test(name.trim()) || (lab && OPTION_RE.test(lab.textContent.trim()))) {
          var v2 = [];
          Array.prototype.forEach.call(sel.options, function (o) { v2.push({ value: o.value, available: !o.disabled && !/unavailable|sold out/i.test(o.textContent.replace(o.value, '')), el: o }); });
          return { vs: vs, group: g, kind: 'select', select: sel, values: v2, checked: sel.value, position: i };
        }
      }
    }
    return null;
  }

  function choose(pi, value) {
    var n = readNative(pi);
    if (!n) return;
    if (n.kind === 'radio') {
      var r = n.values.filter(function (x) { return x.value === value; })[0];
      if (!r || r.el.checked) return;
      r.el.checked = true;
      r.el.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      if (n.select.value === value) return;
      n.select.value = value;
      n.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }

  function build(pi, n) {
    var id = 'ss-pp-' + (++uid);
    var root = el('div', 'ss-pp', { 'data-ss-phone-picker': '' });
    var head = el('div', 'ss-pp__head');
    var label = el('span', 'ss-pp__label', { id: id + '-label' });
    label.textContent = 'Your phone model';
    head.appendChild(label);
    root.appendChild(head);

    var brands = [];
    n.values.forEach(function (v) { var b = brandOf(v.value); if (brands.indexOf(b) < 0) brands.push(b); });
    var tabs = null;
    if (brands.length > 1) {
      tabs = el('div', 'ss-pp__brands', { role: 'group', 'aria-label': 'Phone brand' });
      brands.forEach(function (b) {
        var t = el('button', 'ss-pp__brand', { type: 'button', 'data-brand': b, 'aria-pressed': 'false' });
        t.textContent = b;
        tabs.appendChild(t);
      });
      root.appendChild(tabs);
    }

    var trigger = el('button', 'ss-pp__trigger', { type: 'button', 'aria-expanded': 'false', 'aria-controls': id + '-panel', 'aria-labelledby': id + '-label ' + id + '-current' });
    var current = el('span', 'ss-pp__current', { id: id + '-current' });
    var status = el('span', 'ss-pp__status');
    var caret = el('span', 'ss-pp__caret', { 'aria-hidden': 'true' });
    trigger.appendChild(current); trigger.appendChild(status); trigger.appendChild(caret);
    root.appendChild(trigger);

    var panel = el('div', 'ss-pp__panel', { id: id + '-panel', hidden: '' });
    var searchWrap = el('div', 'ss-pp__search');
    var sLabel = el('label', 'visually-hidden', { for: id + '-q' }); sLabel.textContent = 'Search phone models';
    var search = el('input', 'ss-pp__input', { id: id + '-q', type: 'search', placeholder: 'Search, e.g. 15 Pro Max', autocomplete: 'off', inputmode: 'search' });
    searchWrap.appendChild(sLabel); searchWrap.appendChild(search);
    panel.appendChild(searchWrap);
    var list = el('div', 'ss-pp__list');
    panel.appendChild(list);
    var empty = el('p', 'ss-pp__empty', { hidden: '' });
    empty.textContent = "No match. We only list the models this case is made for.";
    panel.appendChild(empty);
    var live = el('p', 'visually-hidden', { 'aria-live': 'polite' });
    panel.appendChild(live);
    root.appendChild(panel);

    var note = el('p', 'ss-pp__note');
    note.textContent = n.values.length + ' models, newest first';
    root.appendChild(note);

    // groups in native order
    var groups = {}, order = [];
    n.values.forEach(function (v) {
      var s = seriesOf(v.value);
      if (!groups[s]) { groups[s] = []; order.push(s); }
      groups[s].push(v.value);
    });
    order.forEach(function (s, gi) {
      var sec = el('div', 'ss-pp__group', { role: 'group', 'aria-labelledby': id + '-g' + gi, 'data-brand': brandOf(groups[s][0]) });
      var h = el('p', 'ss-pp__group-title', { id: id + '-g' + gi }); h.textContent = s;
      var row = el('div', 'ss-pp__chips');
      groups[s].forEach(function (val) {
        var b = el('button', 'ss-pp__chip', { type: 'button', 'data-value': val, 'aria-pressed': 'false' });
        var t = el('span', 'ss-pp__chip-text'); t.textContent = val;
        var u = el('span', 'ss-pp__chip-na'); u.textContent = 'sold out';
        b.appendChild(t); b.appendChild(u);
        row.appendChild(b);
      });
      sec.appendChild(h); sec.appendChild(row);
      list.appendChild(sec);
    });

    var state = { brand: null, open: false };

    function setOpen(o, focusSearch) {
      state.open = o;
      trigger.setAttribute('aria-expanded', String(o));
      root.classList.toggle('is-open', o);
      if (o) { if (search.value) { search.value = ''; filter(); } panel.removeAttribute('hidden'); if (focusSearch && window.matchMedia('(pointer: fine)').matches) search.focus(); }
      else { panel.setAttribute('hidden', ''); }
    }
    function filter() {
      var q = norm(search.value), shown = 0;
      list.querySelectorAll('.ss-pp__group').forEach(function (g) {
        var brandOk = !state.brand || g.dataset.brand === state.brand;
        var any = 0;
        g.querySelectorAll('.ss-pp__chip').forEach(function (c) {
          var ok = brandOk && (!q || norm(c.dataset.value).indexOf(q) >= 0);
          c.hidden = !ok; if (ok) any++;
        });
        g.hidden = !any; shown += any;
      });
      empty.hidden = shown > 0;
      live.textContent = search.value ? shown + (shown === 1 ? ' model' : ' models') + ' found' : '';
    }
    function setBrand(b) {
      state.brand = b;
      if (tabs) tabs.querySelectorAll('.ss-pp__brand').forEach(function (t) { t.setAttribute('aria-pressed', String(t.dataset.brand === b)); });
      filter();
    }

    function sync() {
      var nn = readNative(pi);
      if (!nn) return;
      var avail = {};
      nn.values.forEach(function (v) { avail[v.value] = v.available; });
      list.querySelectorAll('.ss-pp__chip').forEach(function (c) {
        var on = c.dataset.value === nn.checked;
        c.setAttribute('aria-pressed', String(on));
        c.classList.toggle('is-unavailable', avail[c.dataset.value] === false);
      });
      current.textContent = nn.checked || 'Choose your model';
      status.textContent = nn.checked && avail[nn.checked] === false ? ' (sold out in this style)' : '';
      if (!state.brand && tabs && nn.checked) setBrand(brandOf(nn.checked));
    }

    trigger.addEventListener('click', function () { setOpen(!state.open, true); });
    list.addEventListener('click', function (e) {
      var c = e.target.closest('.ss-pp__chip');
      if (!c) return;
      choose(pi, c.dataset.value);
      list.querySelectorAll('.ss-pp__chip').forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
      current.textContent = c.dataset.value;
      setOpen(false);
      trigger.focus();
    });
    if (tabs) tabs.addEventListener('click', function (e) {
      var t = e.target.closest('.ss-pp__brand');
      if (!t) return;
      setBrand(t.dataset.brand);
      setOpen(true, false);
    });
    search.addEventListener('input', filter);
    search.addEventListener('search', filter);
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = list.querySelector('.ss-pp__chip:not([hidden])');
        if (first) first.click();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        var f = list.querySelector('.ss-pp__chip:not([hidden])'); if (f) f.focus();
      }
    });
    list.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) < 0) return;
      var chips = Array.prototype.filter.call(list.querySelectorAll('.ss-pp__chip'), function (c) { return !c.hidden && !c.closest('.ss-pp__group').hidden; });
      var i = chips.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var j = e.key === 'Home' ? 0 : e.key === 'End' ? chips.length - 1 : (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? Math.min(i + 1, chips.length - 1) : Math.max(i - 1, 0);
      if ((e.key === 'ArrowUp') && i === 0) { search.focus(); return; }
      chips[j].focus();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) { e.stopPropagation(); setOpen(false); trigger.focus(); }
    });
    document.addEventListener('click', function (e) { if (state.open && !root.contains(e.target)) setOpen(false); });

    // Re-sync whenever Dawn swaps the variant-selects (after each option change, incl. other options like colour)
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 60); }).observe(pi, { childList: true, subtree: true });
    root._ssSync = sync;
    sync();
    filter();
    return root;
  }

  function init(pi) {
    if (!pi || pi.dataset.ssPpInit) return;
    var n = readNative(pi);
    if (!n || n.values.length < MIN_VALUES) return;
    pi.dataset.ssPpInit = '1';
    var root = build(pi, n);
    // Model first in the option list: picker goes above the other options; otherwise below them.
    if (n.position === 0) n.vs.parentNode.insertBefore(root, n.vs);
    else n.vs.parentNode.insertBefore(root, n.vs.nextSibling);
    pi.classList.add('ss-pp-on');
  }

  function initAll() { document.querySelectorAll('product-info').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('product-info:loaded', function (e) { init(e.target.closest ? e.target.closest('product-info') || e.target : e.target); });
})();
